import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ResponsiveGrid from "../grid/responsiveGrid";
import { ConvertISOToDate } from "../util";
import { useUserAuth } from "../contexts/authContext";
import { CustomPagination } from "../customPagination";

export function LoginHistory({ user, setUser }) {
    const [data, setData] = useState(null);
    const [sortModel, setSortModel] = useState([{ field: "login_time", sort: "desc" }]);

    const { handleFailedFetch } = useUserAuth();

    const handleClose = () => {
        setData(null);
        setUser(null);
    };

    useEffect(() => {
        if (!user) {
            return;
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(user)
        };
        fetch("api/loginhistory/get", requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then((data) => setData(data))
            .catch((err) => handleFailedFetch(err));

        return () => {
            setData(null);
        };
    }, [user]);

    const columns = [
        {
            field: "login_time",
            headerName: "Login Submitted",
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "login_successful",
            headerName: "Successful",
            flex: 1,
            renderCell: ({ row }) => (
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", height: "100%" }}>
                    <Typography variant="body1" color={row.login_successful ? "rgb(102, 187, 106)" : "rgb(244, 67, 54)"}>
                        {row.login_successful ? "Successful" : "Unsuccessful"}
                    </Typography>
                </Box>
            )
        }
    ];

    return (
        <Dialog open={Array.isArray(data) ? true : false} onClose={() => handleClose()} maxWidth="md" data-testid="dialog">
            <DialogContent>
                <Box sx={{ marginTop: "5px", display: "flex", flexDirection: "column", gap: "5px", minWidth: 410 }}>
                    <Box>
                        <ResponsiveGrid
                            disableVirtualization
                            rows={data}
                            columns={columns}
                            disableRowSelectionOnClick
                            autoHeight
                            slots={{ pagination: CustomPagination }}
                            initialState={{ pagination: { paginationModel: { pageSize: 6 } } }}
                            sx={{
                                bgcolor: "#121212"
                            }}
                            sortModel={sortModel}
                            onSortModelChange={(model) => setSortModel(model)}
                        />
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => handleClose()}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
